import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import Dashboard from './Dashboard';


ReactDOM.render(<Dashboard />, document.getElementById('root'));
